import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { QueryClientProvider, QueryClient } from "react-query"

console.log("account", CLOUDFLARE_ACCOUNT_ID)
console.log("locations kv", CLOUDFLARE_LOCATIONS_KV_ID)
console.log("menus kv", CLOUDFLARE_MENUS_KV_ID)
console.log("token", CLOUDFLARE_KV_READ_TOKEN)

const queryClient = new QueryClient()

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
